// Country (ISO alpha-2) of the logged customer, from the login response (backend #1818).
//
// Cached like sugestoes-conteudo.js because screens that render right after login need it
// synchronously. Unknown means Brazil — the platform behaved like that before foreign customers.
const STORAGE_KEY = "mention.customerCountry";

export const setCustomerCountry = (value) => {
  if (value) localStorage.setItem(STORAGE_KEY, value);
  else localStorage.removeItem(STORAGE_KEY);
};

// True for customers outside Brazil: Brazil-only content (Portuguese tutorial video, the
// Brazilian WhatsApp channel) is not shown to them.
export const isForeignCustomer = () => {
  const country = localStorage.getItem(STORAGE_KEY);
  return !!country && country !== "BR";
};

// Country of a registered customer company (#1374), used by the admin screens. Outside Brazil there
// is no CPF/CNPJ nor Asaas: the document is a free, optional Tax ID and the address uses free-text State/ZIP.
export const BRAZIL = "BR";

export const isBrazil = (countryCode) => !countryCode || countryCode === BRAZIL;

export const taxIdLabel = (countryCode) => {
  if (isBrazil(countryCode)) return "CPF/CNPJ";
  return countryCode === "US" ? "EIN" : "Tax ID";
};

export const cpfCnpjMask = (document) => {
  const digits = document ? document.replace(/\D/g, "") : "";
  return digits.length <= 11 ? "###.###.###-##" : "##.###.###/####-##";
};
